var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoadingOrderData ? _c('div', [_c('span', {
    staticClass: "icon mr-1"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1), _vm._m(0)]) : _vm.error ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('span', {
    staticClass: "icon mr-1"
  }, [_c('FontAwesomeIcon', {
    staticClass: "text-danger",
    attrs: {
      "icon": "exclamation-triangle"
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_c('small', [_vm._v(_vm._s(_vm.error))])])]) : _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.pageTitle,
      "icon": "pe-7s-note2",
      "data-id": _vm.salesOrder.id
    },
    scopedSlots: _vm._u([_vm.salesOrder.linked_sales_order_identifiers ? {
      key: "subTitle",
      fn: function () {
        return [_vm._v(" Gelinkte orders: "), _vm._l(_vm.salesOrder.linked_sales_order_identifiers, function (identifier, index) {
          return _c('span', {
            key: index,
            staticClass: "linked-order"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'OrderDetailOverview',
                params: {
                  salesOrderIdentifier: identifier
                }
              }
            },
            domProps: {
              "textContent": _vm._s(identifier)
            }
          }), _c('span', {
            staticClass: "comma-separator"
          }, [_vm._v(" , ")])], 1);
        })];
      },
      proxy: true
    } : null], null, true)
  }), _c('b-row', [_c('b-col', [_c('ul', {
    staticClass: "nav nav-tabs mb-4"
  }, _vm._l(_vm.visibleTabs, function (tab, index) {
    return _c('li', {
      key: index,
      staticClass: "nav-item"
    }, [_c('router-link', {
      staticClass: "nav-link",
      class: {
        active: _vm.isMatchedRoute(tab.matchRouteNames)
      },
      attrs: {
        "tag": "a",
        "to": {
          name: tab.routeName
        }
      }
    }, [_c('i', [_vm._v(_vm._s(tab.name))])])], 1);
  }), 0), _c('router-view', {
    key: _vm.lastUpdate,
    attrs: {
      "sales-order": _vm.salesOrder
    },
    on: {
      "dataChanged": function ($event) {
        return _vm.refreshOrder();
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "label"
  }, [_c('small', [_vm._v(" Ordergegevens worden geladen… ")])]);

}]

export { render, staticRenderFns }